import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "../../css/home2.css";
import home from "../../json/home.json";


function HomeSection2() {
  const [hoveredItem, setHoveredItem] = useState(null);
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate('/services'); // Add your path here
  };

  //const activeContent = home.items.find((item) => item.id === activeItem)?.content;

  return (
    <section id="section3">
      <div className="row">
        <div className="col-12 text-center">
          <p className="h1 section2-title mt-5">Servicios</p>
        </div>
      </div>
      <div className="row justify-content-center align-items-center">
        {home.items.map((item) => (
          <div
            key={item.id}
            className="col-5 col-sm-4 col-md-4 col-lg-3 service-container text-center"
            >
            <div className="section-model p-3"
              onMouseEnter={() => setHoveredItem(item.id)}
              onMouseLeave={() => setHoveredItem(null)}
              onClick={() => handleNavigation()} // Add your path here
              onKeyDown={(e) => e.key === 'Enter' && handleNavigation()}
              role="button"
              tabIndex={0}>
              <img
                src={require(`../../img/${hoveredItem === item.id ? item.activeImg : item.defaultImg}`)}
                className="img-thumbnail service-img"
                alt={item.title}
                width="100"
              />
              <p className="h5 mt-2 serv-title">{item.title}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="row">
        <div className="col-12 text-justify">
          {/*activeContent && (
            <div className="content-box p-1">
              <p className='activecontent text-center text-md-start'>{activeContent}</p>
            </div>
          )*/}
          <div className="d-flex justify-content-center mt-3">
            <button className="btn btn-servicessec2" onClick={() => handleNavigation()}>Ver todos los Servicios</button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomeSection2;